import { render } from "./KPIReport.vue?vue&type=template&id=ef699f04&scoped=true"
import script from "./KPIReport.vue?vue&type=script&lang=js"
export * from "./KPIReport.vue?vue&type=script&lang=js"

import "./KPIReport.vue?vue&type=style&index=0&id=ef699f04&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef699f04"]])

export default __exports__